import "./MemberHeader.css";
import React from "react";
import PropTypes from "prop-types";
import NotificationItem from "gradifui/components/header/NotificationItem";
import LabelledItem from "gradifui/components/header/LabelledItem";
import BaseHeader from "gradifui/components/header/BaseHeader";
import UserItem from "gradifui/components/header/UserItem";
import LogoItem from "gradifui/components/header/LogoItem";
import { URLS } from "util/constants";
import Propulator from "higher-order/Propulator";

class MemberHeader extends React.Component {
    static propTypes = {
        selected: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
    };

    _getAccountsHeader() {
        return <LabelledItem name="accounts" icon="icon-bank" label="My Accounts" url={URLS.MEMBER.MY_ACCOUNTS} />;
    }

    render() {
        const {
            session,
            memberFeatures
        } = this.props;

        const notificationCount = this.props.notificationCount ?? 0;
        const selected = this.props.selected ?? "";
        const unreadNotificationCount = this.props.unreadNotificationCount ?? 0;
        const hasLearningCenter = memberFeatures?.hasLearningCenter ?? false;
        const hasRefi = memberFeatures?.hasRefi ?? false;
        const hasPslf = memberFeatures?.hasPslf ?? false;
        const hasOtherSentinelAccounts = memberFeatures?.hasOtherSentinelAccounts ?? false
        const isLoggedIn = session?.isLoggedIn ?? false;
        const isImpersonating = session?.isImpersonating ?? false;
        const user = session?.user ?? {};
        const notificationCenter = session?.featureToggles?.notificationCenter ?? false;
        const canManageAccounts = memberFeatures?.canManageAccounts;
        const hasTuitionReimbursement = memberFeatures?.hasTuitionReimbursement;
        const hasHistory = memberFeatures?.hasMatchHistory 
            || memberFeatures?.hasReimbursementHistory
            || memberFeatures?.slp?.hasFundedTransactions
            || memberFeatures?.saveUp?.hasFundedTransactions;
        const personasUrl = new URL(session.loginPath).origin + "/personas";
        const loginAndSecurityUrl = new URL(session.loginPath).origin + "/login-and-security";

        return (
            <BaseHeader selectedHeaderItem={selected}>
                <nav className="left-section">
                    <LogoItem url={URLS.MEMBER.DASHBOARD} />
                    <LabelledItem name="dashboard" icon="icon-gauge" label="Dashboard" url={URLS.MEMBER.DASHBOARD} />
                    {(canManageAccounts || hasTuitionReimbursement || hasHistory) &&
                        this._getAccountsHeader()
                    }
                    {hasLearningCenter &&
                        <LabelledItem name="learning" icon="icon-book" label="Learn" url={URLS.MEMBER.LEARNING_CENTER} />
                    }
                    {hasRefi &&
                        <LabelledItem name="refi" icon="icon-sliders" label="Refinancing" url={URLS.MEMBER.REFINANCING} />
                    }
                    {hasPslf && <LabelledItem name="pslf" icon="icon-handshake-angle-solid" label="Loan Forgiveness" url={URLS.MEMBER.PSLF} />}
                </nav>

                <nav className="right-section">
                    {isLoggedIn &&
                        <React.Fragment>
                            {notificationCenter && (notificationCount > 0) &&
                                <NotificationItem name="notifications" notificationCount={unreadNotificationCount} />
                            }
                            <UserItem user={user} isImpersonating={isImpersonating} showChildrenOnHover={true}>
                                <LabelledItem name="account" label="Profile Settings" url={URLS.MEMBER.PROFILE} />
                                {hasOtherSentinelAccounts &&
                                    <LabelledItem name="accounts" label="Switch Account" url={personasUrl} />
                                }
                                <LabelledItem name="security" label="Login & Security" url={loginAndSecurityUrl} />
                                <LabelledItem name="external-help" label="Help" url={URLS.EXTERNAL.HELP.MEMBER} />
                                <LabelledItem name="help" label="Contact Us" url={URLS.MEMBER.CONTACT} />
                                <LabelledItem label="Log Out" url="/logout" />
                            </UserItem>
                        </React.Fragment>
                    }
                    {!isLoggedIn &&
                        <React.Fragment>
                            <LabelledItem name="external-help" icon="icon-help" label="Help" url={URLS.EXTERNAL.HELP.MEMBER} />
                            <LabelledItem name="help" label="Contact Us" url={URLS.MEMBER.CONTACT} />
                            <LabelledItem label="Log In" url={session.loginPath} />
                        </React.Fragment>
                    }
                </nav>
            </BaseHeader>
        );
    }
}

export default Propulator(MemberHeader, {
    sessionStore: [
        "session",
        "memberFeatures",
        "unreadNotificationCount",
        "notificationCount"
    ]
});
